import { type ClassValue, clsx } from 'clsx'
import copy from 'copy-to-clipboard'
import { t } from 'i18next'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function noop() {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
}

/**
 * Copies text to the clipboard and returns true if successful, false otherwise.
 * @param text - The text to copy to the clipboard.
 * @returns The result of the copy operation.
 */
export function copyTextToClipboard(text: string) {
    const copySuccess = copy(text, {
        format: 'text/plain',
        message: t('instructions.select_all_clipboard'),
    })
    return copySuccess
}
